import { Alert, Button, Card, CardContent, Typography } from "@mui/material";

import { ContentArea } from "components/ContentArea";
import { useUser } from "components/UserProvider";
import { APP_TITLE } from "defs";

const Login: React.FC = () => {
  const { isPendingApproval } = useUser();

  const handleSSOLogin = () => {
    window.location.href = "/oauth2/start";
  };

  return (
    <ContentArea
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        justifyContent: "center",
      }}
    >
      <Card sx={{ maxWidth: 400, p: 1, width: "100%" }}>
        <CardContent sx={{ "&:last-child": { pb: "inherit" } }}>
          <Typography sx={{ fontWeight: "bold" }} variant="h5">
            {APP_TITLE}
          </Typography>
          {isPendingApproval ? (
            <Alert
              aria-label="Account pending approval"
              severity="info"
              sx={{ mt: 2 }}
            >
              Your account is pending administrator approval. You will be able
              to access the app once your account has been verified.
            </Alert>
          ) : null}
          <Button
            color="primary"
            fullWidth
            onClick={handleSSOLogin}
            size="large"
            sx={{ mb: 1, mt: 2 }}
            variant="contained"
          >
            Login with SSO
          </Button>
        </CardContent>
      </Card>
    </ContentArea>
  );
};

export default Login;
